import React from "react";
import Banner6 from "../partials/Banner/Banner6";
import Section1 from "../includes/PorchPiracyAStateFelony/Section1";
import { Helmet } from "react-helmet";

const PorchPiracyAStateFelony = ({ devUrl }) => {
  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": "https://brainbox.company/blogs/package-theft-punishments",
    },
    headline: "Porch piracy is a state felony",
    image: "https://brainbox.company/images/blogs/blog-11.png",
    author: {
      "@type": "Organization",
      name: "Brain Box",
      url: "https://brainbox.company",
    },
    publisher: {
      "@type": "Organization",
      name: "Brain Box",
      logo: {
        "@type": "ImageObject",
        url: "https://brainbox.company/images/logo-b.png",
      },
    },
    datePublished: "2023-08-01",
    dateModified: "2023-08-02",
  };

  const imgPath = "url(" + devUrl + "images/our-team/ourteam-banner.png)";

  const bgColor = "$blue-color";
  const minHeight = "400px";

  return (
    <>
      <Helmet>
        <title>Porch Piracy is a State Felony</title>
        <meta
          name="description"
          content="Bills such as the 'Porch Pirates Act of 2022' have recently been passed in the US to declare package theft as a felony."
        />
        <script type="application/ld+json">
          {JSON.stringify(schemaMarkup)}
        </script>
        <link
          rel="canonical"
          href="https://brainbox.company/blogs/package-theft-punishments"
        />
      </Helmet>
      <main>
        <article className="our-team">
          <Banner6
            imgPath={imgPath}
            bgColor={bgColor}
            minHeight={minHeight}
            text1={"Porch Piracy is a State Felony"}
          />
          <div className="bg-design">
            <Section1 url={devUrl} />
          </div>
        </article>
      </main>
    </>
  );
};

export default React.memo(PorchPiracyAStateFelony);
